import { CollectibleId_Schema } from "@/services/collectibles";
import { CollectibleElastic_Schema } from "@/services/collectibles/elastic";
import { CategoryId, CategoryId_Schema } from "@/services/collection/categories/categoriesSchema";
import { ApiResponse_ImageNoId_Schema } from "@/services/images";
import { PriceNumericOrEmpty_Schema } from "@/services/prices";
import { DateString_Schema } from "@/utilities";
import { z } from "zod";

export const AiIdentificationId_Schema = z.uuid();

const AiIdentification_Base_Schema = z.object({
  id: AiIdentificationId_Schema,
  categoryId: CategoryId_Schema,
  name: z.string(),
  priceFrom: PriceNumericOrEmpty_Schema,
  priceTo: PriceNumericOrEmpty_Schema,
  images: z.array(ApiResponse_ImageNoId_Schema),
  description: z.string().nullable(),
  confidenceScore: z.number(),
  parameters: z.array(
    z.object({
      parameterId: z.number(),
      value: z.string(),
      valueId: z.number(),
    })
  ),
});

const AiIdentification_LegoSet_Schema = AiIdentification_Base_Schema.extend({
  categoryId: z.literal(CategoryId.LegoSets),
  catalogueItem: z.object({
    id: CollectibleId_Schema,
    number: z.string(),
    themeName: z.string().optional(),
    year: z.number(),
    partsCount: z.number(),
    weight: z.string(),
    dimensions: z.string(),
  }),
});

export const AiIdentification_LegoMinifigure_Schema = AiIdentification_Base_Schema.extend({
  categoryId: z.literal(CategoryId.LegoMinifigures),
  catalogueItem: z.object({
    id: CollectibleId_Schema,
    number: z.number(),
    partsCount: z.number(),
  }),
});

const AiIdentification_OtherCategories_Schema = AiIdentification_Base_Schema.extend({
  categoryId: z.union([
    z.literal(CategoryId.Pokemon), //
    z.literal(CategoryId.SportsCards),
    z.literal(CategoryId.VinylRecords),
    z.literal(CategoryId.BoardGames),
  ]),
  collectible: CollectibleElastic_Schema.nullable(),
});

export const AiIdentification_Schema = z.discriminatedUnion("categoryId", [AiIdentification_LegoMinifigure_Schema, AiIdentification_LegoSet_Schema, AiIdentification_OtherCategories_Schema]);

export const AiIdentificationSummary_Schema = z.object({
  id: AiIdentificationId_Schema,
  categoryId: CategoryId_Schema,
  name: z.string(),
  datetime: DateString_Schema,
  priceFrom: PriceNumericOrEmpty_Schema,
  priceTo: PriceNumericOrEmpty_Schema,
  images: z.array(ApiResponse_ImageNoId_Schema),
});
